import styled from 'styled-components';

export const Container = styled.div`
  width: calc(100% - 6rem);
  margin-left: 6rem;
  height: calc(100vh - 7rem);
  overflow-y: auto;
  background-color: #f1edee;
  @media (max-width: 601px) {
    width: 100%;
    margin-left: 0;
    height: calc(100vh - 4rem);
  }
`;

export const MenuContainer = styled.div`
  margin-top: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > p {
    font-size: 18px;
    font-weight: 700;
    color: var(--color-primary);
  }
`;

export const MenuItemContainer = styled.div`
  margin: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  footer {
    height: 50px;
    background-color: #fff;
    filter: drop-shadow(0px -4px 4px rgba(0, 0, 0, 0.25));
    margin-top: 242px;
  }

  .card {
    width: 250px;
    height: 210px;
    margin: 20px;
    background: var(--linear-blue);
    border-radius: 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    color: #fff;

    > P {
      margin-top: 20px;
      font-size: 24px;
      font-weight: 500;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 5rem;
  @media (max-width: 1025px) {
    padding: 0 2rem;
    .cards {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      margin-bottom: 1rem;
    }
  }
`;

export const Infos = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr) 2fr;
  gap: 2rem;
  @media (max-width: 601px) {
    gap: 0.5rem;
  }
  @media (max-width: 415px) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 0.5rem;
  }
`;

export const ContainerGraph = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  @media (min-width: 2000px) {
    height: 48rem;
  }
  @media (max-width: 769px) {
    display: block;
  }
`;

export const Resume = styled.div`
  display: flex;
  height: 26rem;
  gap: 1rem;
  width: 40%;

  .cards {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }
  .graphs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
  }
  @media (min-width: 2000px) {
    height: 100%;
    .graphs {
      div {
        height: 49%;
      }
    }
  }
  @media (max-width: 769px) {
    width: 100%;
    height: auto;
    padding: 0;
    margin-bottom: 1rem;
    align-items: flex-start;
    .graphs {
      width: 100%;
      display: flex;
      flex-direction: row;
    }
  }
`;
export const Subtitle = styled.div`
  height: 70px;
  width: 100%;
  border: none;
  display: flex;
  align-items: center;
  padding: 2rem;

  p {
    color: #000000;
    font-size: 28px;
    font-weight: 600;
  }

  @media (max-width: 769px) {
    p {
      font-size: 22px;
    }
  }
  @media (max-width: 415px) {
    p {
      font-size: 16px;
    }
  }
`;
